<template>
	<div class="animate_animated animate__slideInRight">
		<div class="fixed inset-x-0 top-0 z-20">
		<div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
       <div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
			<div class="flex items-center px-4 py-4">
				<div class="flex items-center w-full">
					<a  @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
					<span class="text-base text-content font-medium ml-4">Search Enquiry</span>
				</div>
			</div>
		</div>
    </div>
    <div class="pt-20 mt-2 bg-white">
    <div class="bg-white min-h-screen p-4">
      <form>
        <div class="mb-6 relative">
          <label for=""
            class="text-main text-opacity-80 text-sm block mb-2 bg-white">Saved Searches</label>
          <select v-model="search.ss_id"
            class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option
              v-for="(s, key) in saved_searches"
              :key="key"
              :value="s.id"
            >{{s.name}}</option>
          </select>
        </div>
        <div class="mb-10">
          <label for="" class="text-main text-opacity-80 text-sm block mb-4 bg-white ">Property For</label>
          <div class="flex text-sm">
            <span class="radio-selection">
              <input type="radio" v-model="search.transaction_type_id" name="propertyFor" value="1" id="Sale" class="hidden">
              <label for="Sale" class="bg-gray-100 py-3 px-6 text-main rounded-xl pills mr-3"> Sale </label>
            </span>
             <span class="radio-selection">
              <input type="radio" v-model="search.transaction_type_id" name="propertyFor" value="2" id="Rental" class="hidden">
              <label for="Rental" class="bg-gray-100 py-3 px-6 text-main rounded-xl pills"> Rental </label>
            </span>
          </div>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Name</label>
          <input type="text" v-model="search.name" placeholder="Name" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Email</label>
          <input type="email" v-model="search.email" placeholder="Email" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Mobile</label>
          <input type="number" v-model="search.mobile" placeholder="Mobile No" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Created From</label>
          <input type="date" v-model="search.created_at_from" placeholder="Created From" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Created Upto</label>
          <input type="date" v-model="search.created_at_upto" placeholder="Created Upto" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Building Type</label>
          <select v-model="search.building_type" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select the type</option>
            <option
              v-for="(bt, key) in leadKeysList.building_types"
              :key="key"
              :value="bt.id"
            >{{bt.name}}</option>
          </select>
        </div>
         <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Property Type</label>
          <select v-model="search.property_type" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Property Type</option>
            <option
              v-for="(pt, key) in propertyType"
              :key="key"
              :value="pt"
            >{{pt}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for=""
            class="text-main text-opacity-80 text-sm block mb-2 bg-white">Furnishings</label>
          <select v-model="search.furnishing"
            class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Furnishings</option>
            <option value='Yes'>Yes</option>
            <option value='No'>No</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Configuration</label>
          <select v-model="search.configuration" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Configuration</option>
           <option
              v-for="(c, key) in leadKeysList.configuration"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Status</label>
          <multiselect v-model="search.lead_statuses" :searchable="false"  placeholder="Select Status" label="name" valueProp="id" :options="statusList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative" v-if="is_status_dead">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Dead Reason</label>
          <select v-model="search.dead_reason_id" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Dead Reason</option>
            <option
              v-for="(s, key) in deadReasons"
              :key="key"
              :value="s.id"
            >{{s.reason}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Land Type</label>
          <select v-model="search.land_type" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Land Type</option>
            <option
              v-for="(c, key) in leadKeysList.land_types"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>

        <div class="mb-6 relative" v-if="showLeaseTypeField">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Lease Type</label>
          <select v-model="search.lease_type" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Lease Type</option>
            <option
              v-for="(c, key) in leadKeysList.lease_types"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Zone</label>
          <select v-model="search.zone" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Zone</option>
           <option
              v-for="(c, key) in leadKeysList.zones"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Enquiry Type</label>
          <select v-model="search.enquiry_type" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select Enquiry Type</option>
           <option
              v-for="(c, key) in leadKeysList.enquiry_type"
              :key="key"
              :value="c"
            >{{c}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Sources</label>
          <multiselect v-model="search.source_id" :searchable="false"  placeholder="Select Sources" label="name" valueProp="id" :options="sourceList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Brokers</label>
          <multiselect v-model="search.broker_ids" :searchable="false"  placeholder="Select Broker" label="name" valueProp="id" :options="cpList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Select Assigned To</label>
          <multiselect v-model="search.user_id" :searchable="false"  placeholder="Select Users" label="name" valueProp="id" :options="userList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Select Lead Created By</label>
          <multiselect v-model="search.lead_created_by_user_id" :searchable="false"  placeholder="Select Users" label="name" valueProp="id" :options="leadCreateUserList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Select Projects</label>
          <multiselect v-model="search.project_ids" :searchable="true"  placeholder="Select Projects" label="name" valueProp="id" :options="projectList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Select Properties</label>
          <multiselect v-model="search.property_ids" :searchable="true"  placeholder="Select Properties" label="name" valueProp="id" :options="propertiesList" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative" v-if="meeting_executive">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Select Closing Executive</label>
          <multiselect v-model="search.closing_executive" :searchable="true"  placeholder="Select Closing Executive" label="name" valueProp="id" :options="leadKeysList.closing_executives" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">City</label>
          <select v-model="search.city_ids" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none">
            <option selected disabled>Select City</option>
            <option
              v-for="(r, key) in leadKeysList.cities"
              :key="key"
              :value="r.id"
            >{{r.name}}</option>
          </select>
        </div>
        <div class="mb-6 relative">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white z-10">Locality</label>
          <multiselect v-model="search.locality_ids" :searchable="true"  :options-limit="leadKeysList.locality?.length"  placeholder="Select Locality" label="name" valueProp="id" :options="leadKeysList.locality" mode="tags" :taggable="true" class="multiselect-outer-wrapper"></multiselect>
        </div>
        <div class="mb-6 relative">
          <el-checkbox class="ml-2" v-model="search.set_search">  Saved Search</el-checkbox>
        </div>
        <div class="mb-6 relative" v-if="search.set_search">
          <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Search Name</label>
          <input type="text" v-model="search.search_name" placeholder="Search Name" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
        </div>
        <div class="mt-10">
          <a @click="clearFilters" class="clearFilter"> Clear Filters</a>
          <button type="button" @click="performSearch" class="bg-primary text-base font-semibold text-white rounded-xl p-5 w-full disabled:opacity-50" >Filter</button>
        </div>
      </form>
    </div>
  </div>
	</div>
</template>
<script>

import Multiselect from '@vueform/multiselect'
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      saved_searches: [],
      showLeaseTypeField: false,
      search: {
        ss_id: null,
        name: null,
        email: null,
        mobile: null,
        lead_statuses: [],
        source_id: [],
        user_id: [],
        lead_created_by_user_id:[],
        created_at_from: null,
        created_at_upto: null,
        city_ids: null,
        locality_ids: [],
        project_ids: [],
        property_ids: [],
        broker_ids: [],
        transaction_type_id: null,
        building_type: null,
        property_type: null,
        configuration: null,
        dead_reason_id: null,
        furnishing: null,
        set_search:  false,
        search_name: null,
        closing_executive: [],
        land_type: null,
        lease_type: null,
        zone: null,
        enquiry_type: null
      },
    }
  },
  methods: {
    toggleLeaseTypeField() {
      this.showLeaseTypeField = this.search.land_type === 'Lease Hold';
    },
    performSearch(){
      this.$store.dispatch('setAdvSParams', this.search);
      if (this.$route.query.type === 'Backlogs') {
        this.$router.push({name: 'Backlogs'})
      } else if (this.$route.query.type === 'TodaysCalls') {
         this.$router.push({name: 'TodaysCalls'})
      } else {
        this.$router.push({name: 'Enquiry'})
      }
    },
    seedDefaults(){
      this.search = this.advSParams
      this.search.search_name = null
      this.search.set_search = false
    },
    clearFilters(){
      this.search = {
        ss_id: null,
        name: null,
        email: null,
        mobile: null,
        lead_statuses: [],
        source_id: [],
        user_id: [],
        lead_created_by_user_id: [],
        created_at_from: null,
        created_at_upto: null,
        city_ids: null,
        locality_ids: [],
        property_ids: [],
        project_ids: [],
        broker_ids: [],
        transaction_type_id: null,
        building_type: null,
        property_type: null,
        configuration: null,
        furnishing: null,
        set_search:  false,
        search_name: null,
        closing_executive: [],
        land_type: null,
        lease_type: null,
        zone: null,
        enquiry_type: null
      }
      this.$store.dispatch('setAdvSParams', {});
    }
  },
  created(){
    if(Object.keys(this.advSParams).length > 0){
      this.seedDefaults();
    }
    this.$axios
      .get(`mobile_crm/saved_searches`)
      .then(res => {
        console.log("Updated schema:", JSON.stringify(res.data.searches, null, 2));
        this.saved_searches = res.data.searches;
      })
      .catch(err => console.log(err));

  },
  computed: {
    leadKeysList(){
      return this.$store.getters.leadKeys;
    },
    projectList(){
      return this.$store.getters.projectMaster;
    },
    propertiesList(){
      return this.$store.getters.propertiesMaster;
    },
    userList() {
      return this.$store.getters.usersMaster;
    },
    leadCreateUserList() {
      return this.$store.getters.leadUsersMaster;
    },
    sourceList(){
      return this.$store.getters.sourcesMaster;
    },
    statusList(){
      return this.$store.getters.statusesMaster;
    },
    advSParams(){
      return this.$store.getters.advSParams;
    },
    cpList() {
      return this.$store.getters.channel_partners;
    },
    deadReasons() {
      return this.$store.getters.deadReasons;
    },
    deadStatusIds() {
      return this.$store.getters.deadStatusIds;
    },
    propertyKeysList(){
      return this.$store.getters.propertyKeys;
    },
    meeting_executive() {
      return this.$store.getters.meeting_executive;
    },
    is_status_dead() {
      if (this.search.lead_statuses) {
        return this.search.lead_statuses.map(s => s.id).some(s => this.deadStatusIds.includes('' + s))
      }
    },
    propertyType() {
      if (this.search.building_type === 1) {
        return this.propertyKeysList.residential_property_type
      } else if (this.search.building_type === 2) {
        return this.propertyKeysList.commercial_property_type
      } else if (this.search.building_type === 3) {
        return this.propertyKeysList.plot_property_type
      } else {
        return []
      }
    },
  },
  watch: {
    'search.land_type': function(newVal) {
      this.showLeaseTypeField = newVal === 'Lease Hold';
      if (newVal !== 'Lease Hold') {
        this.search.lease_type = null;
      }
    }
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css">></style>
<style scoped>
.clearFilter{
  display: table;
  margin:20px auto;
  opacity: .5;
  font-size: 14px;
}
</style>